import React, { useState } from "react";
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  FormHelperText,
  IconButton,
  styled,
} from "@mui/material";
import { Editor } from "@monaco-editor/react";
import { AutoFixHigh, Close, Visibility } from "@mui/icons-material";

export const StyledBox = styled(Box)({
  border: "1px solid #ccc",
  borderRadius: "4px",
  padding: "8px 4px 4px",
});

/**
 * メール本文入力コンポーネント
 * - Monacoエディタ（HTML形式）でメール本文を入力できる
 * - 「コード成形」ボタンでHTML整形、「プレビュー」ボタンでレンダリング結果を確認できる
 * - props: bodyRef (エディタ参照), defaultValue (初期本文), height (エディタ高さ),
 *          required (必須バリデーション設定)
 */
export default function MailBodyComponent({
  bodyRef,
  defaultValue,
  height,
  required,
}: {
  bodyRef: React.MutableRefObject<any>;
  defaultValue: string;
  height: number;
  required?: { value: boolean; message: string };
}) {
  const [mailPreview, setMailPreview] = useState<{
    open: boolean;
    body: string;
  }>({
    open: false,
    body: "",
  });

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        rowGap: 1,
      }}
    >
      <label
        style={{
          position: "absolute",
          top: -10,
          left: 10,
          padding: "0px 6px",
          backgroundColor: "white",
          fontSize: "0.78rem",
          color: required?.message ? "red" : "text.secondary",
        }}
      >
        本文{required?.value ? " *" : ""}
      </label>
      <Box>
        <StyledBox sx={{ borderColor: required?.message ? "red" : "#ccc" }}>
          <Editor
            height={height}
            defaultLanguage="html"
            defaultValue={defaultValue}
            onMount={(editor) => (bodyRef.current = editor)}
            options={{ automaticLayout: true }}
          />
        </StyledBox>
        <FormHelperText error sx={{ ml: 1.75 }}>
          {required?.message ?? ""}
        </FormHelperText>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
        <Chip
          icon={<AutoFixHigh />}
          label="コード成形"
          onClick={() => {
            if (bodyRef.current) {
              bodyRef.current.getAction("editor.action.formatDocument").run();
            }
          }}
        />
        <Chip
          icon={<Visibility />}
          onClick={() =>
            setMailPreview({
              open: true,
              body: bodyRef.current?.getValue() || "",
            })
          }
          label="プレビュー"
        />
      </Box>
      {/* プレビューダイアログ */}
      <Dialog
        open={mailPreview.open}
        onClose={() => setMailPreview((prev) => ({ ...prev, open: false }))}
        maxWidth="md"
        fullWidth
      >
        <IconButton
          onClick={() => setMailPreview((prev) => ({ ...prev, open: false }))}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <Close />
        </IconButton>
        <DialogContent>
          <StyledBox sx={{ p: 1, my: 6 }}>
            <Box dangerouslySetInnerHTML={{ __html: mailPreview.body }} />
          </StyledBox>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
